<template>
  <div class="sticky top-0 z-40 grid items-center w-full h-16 col-auto pl-12 pr-2 bg-white border-b lg:pl-2">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'Topbar'
  }
</script>